import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';

import analysisPropTypes from '../../proptypes/analysis';
import BackLink from '../common/BackLink';
import AnalysisActions from './AnalysisActions';
import AnalysisHeaderText from './AnalysisHeaderText';

const AnalysisHeader = ({
    analysis,
    analysisReference,
    isLoggedIn,
    isEditableAnalysis,
    refreshAnalysis,
}) => {
    const publicVisibility = analysis.publicVisibility;
    const [actualCommitMessage, setActualCommitMessage] = useState(
        analysis.gitCommitMessage
    );

    const [anchorEl, setAnchorEl] = useState(null);
    const showOptions = Boolean(anchorEl);

    return (
        <>
            <Box
                maxWidth="100%"
                backgroundColor="white"
                boxShadow="rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;"
            >
                <Box
                    sx={{
                        maxWidth: '100%',
                        margin: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        py: 1,
                        px: 2,
                    }}
                >
                    {isLoggedIn && analysis.project.id && (
                        <BackLink
                            href={`/projects/${encodeURIComponent(
                                analysis.project.name
                            )}`}
                        />
                    )}
                    <AnalysisHeaderText
                        analysisReference={analysisReference}
                        analysis={analysis}
                        actualCommitMessage={actualCommitMessage}
                        refreshAnalysis={refreshAnalysis}
                        publicVisibility={publicVisibility}
                        isLoggedIn={isLoggedIn}
                    />

                    {isEditableAnalysis && (
                        <>
                            <IconButton
                                size="small"
                                onClick={(event) => {
                                    setAnchorEl(event.currentTarget);
                                }}
                            >
                                <MoreVertIcon />
                            </IconButton>

                            <AnalysisActions
                                analysisId={analysis.id}
                                projectName={analysis.project.name}
                                refreshAnalysis={refreshAnalysis}
                                showOptions={showOptions}
                                anchorEl={anchorEl}
                                setAnchorEl={setAnchorEl}
                                actualCommitMessage={actualCommitMessage}
                                setActualCommitMessage={setActualCommitMessage}
                                publicVisibility={publicVisibility}
                                forcedPublic={analysis?.project.adminForcedPublic}
                            />
                        </>
                    )}
                </Box>
            </Box>
        </>
    );
};

AnalysisHeader.propTypes = {
    analysis: analysisPropTypes,
    analysisReference: analysisPropTypes,
    isLoggedIn: PropTypes.bool,
    isEditableAnalysis: PropTypes.bool,
    refreshAnalysis: PropTypes.func,
};

export default AnalysisHeader;
